import axiosClient from './axiosClient';

const BannerService = {
    getBanners: async (params) => {
        const response = await axiosClient.get('/banners', { params });
        return response.data;
    },
    getAdminBanners: async (params) => {
        const response = await axiosClient.get('/admin/banners', { params });
        return response.data;
    },
    getBanner: async (id) => {
        const response = await axiosClient.get(`/admin/banners/${id}`);
        return response.data;
    },
    createBanner: async (data) => {
        const response = await axiosClient.post('/admin/banners', data);
        return response.data;
    },
    updateBanner: async (id, data) => {
        const response = await axiosClient.put(`/admin/banners/${id}`, data);
        return response.data;
    },
    deleteBanner: async (id) => {
        const response = await axiosClient.delete(`/admin/banners/${id}`);
        return response.data;
    }
};

export default BannerService;
